import { of as observableOf, Observable } from 'rxjs'
import { Component, ViewChild, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { mergeMap } from 'rxjs/operators'
import {
  IBundleDefinition,
  BundleDefinitionODataService,
  RefDiagnosisRelatedGroupODataService,
  IRefDiagnosisRelatedGroup
} from '@exchange/domain/.'
import { ToastrService } from 'ngx-toastr'
import { AppSelectComponent } from 'common-components'
import { UtilService } from '@exchange/app/services'
import { Option } from 'common-components'
import { PagedResult } from 'common-services'

@Component({
  selector: 'app-bundle-definition-edit',
  templateUrl: './bundle-definition-edit.component.html',
  styleUrls: ['./bundle-definition-edit.component.css'],
  standalone: false
})
export class BundleDefinitionEditComponent implements OnInit {
  @ViewChild('refDiagnosisRelatedGroupList', { static: true })
  refDiagnosisRelatedGroupList: AppSelectComponent

  title = 'Edit Bundle Defintion'
  refDiagnosisRelatedGroups: IRefDiagnosisRelatedGroup[] = []
  refDiagnosisRelatedGroupOptions: Option[] = []

  model: IBundleDefinition = {
    RefDiagnosisRelatedGroup: { Id: 0 } as IRefDiagnosisRelatedGroup
  } as IBundleDefinition

  busy: any = null

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private odata: BundleDefinitionODataService,
    private refDiagRelGrpSvc: RefDiagnosisRelatedGroupODataService,
    private toastr: ToastrService,
    private util: UtilService
  ) {
    this.route.params.subscribe(params => {
      const id = +params['id']

      if (id) {
        this.busy = this.odata
          .query()
          .filter(`Id eq ${id}`)
          .expand('RefDiagnosisRelatedGroup')
          .exec()
          .subscribe(response => {
            this.busy = null
            if (response.data.length) {
              this.model = response.data[0]
            } else {
              this.backToList()
            }
          }, this.showError.bind(this))
      } else {
        this.title = 'Add Bundle Definition'
        this.model = {
          Id: 0,
          RefDiagnosisRelatedGroupId: null
        } as IBundleDefinition
      }
    })
  }
  private initializeModel(): Observable<PagedResult<IBundleDefinition>> {
    return this.route.params.pipe(
      mergeMap(params => {
        const bundleDefinitionId = +params['id']
        return this.odata
          .query()
          .filter(`Id eq ${bundleDefinitionId}`)
          .expand('RefDiagnosisRelatedGroup')
          .exec()
      })
    )
  }
  private initializeRefDiagnosisRelatedGroup() {
    return this.refDiagRelGrpSvc
      .query()
      .exec()
      .subscribe(x => {
        this.refDiagnosisRelatedGroups = x.data
        this.refDiagnosisRelatedGroupOptions = x.data.map(y => new Option(y.Id, y.Description, y))

        if (this.model && this.model.RefDiagnosisRelatedGroupId) {
          this.model.RefDiagnosisRelatedGroup = this.refDiagnosisRelatedGroups.find(
            y => y.Id === this.model.RefDiagnosisRelatedGroupId
          )
          this.refDiagnosisRelatedGroupList.active = [
            this.refDiagnosisRelatedGroupOptions.find(
              y => y.id === this.model.RefDiagnosisRelatedGroupId
            )
          ]
        }
      })
  }
  selectRefDiagnosisRelatedGroup = (
    refDiagRelGrpOption: Option = { id: 0, text: '', value: '' } as Option
  ) => {
    this.model.RefDiagnosisRelatedGroup = this.refDiagnosisRelatedGroups.find(
      x => x.Id === refDiagRelGrpOption.id
    )
    this.model.RefDiagnosisRelatedGroupId = +refDiagRelGrpOption.id
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = +params['id']
      const fn = id ? this.initializeEdit.bind(this) : this.initializeAdd.bind(this)

      fn().subscribe(response => {
        this.model = response.data[0]

        this.initializeRefDiagnosisRelatedGroup()
      })
    })
  }
  initializeEdit() {
    return this.initializeModel()
  }

  initializeAdd() {
    this.title = 'Add Bundle Definition'
    const bundleDefinition = {
      Id: 0,
      Name: '',
      EpisodeTypeName: '',
      SystemEpisodeTypeId: 0,
      AccountingEpisodeTypeName: '',
      AtRisk: false,
      Description: '',
      RefDiagnosisRelatedGroupId: 0
    } as IBundleDefinition
    const paged = {
      skipped: 0,
      rowCount: 1,
      data: [bundleDefinition]
    } as PagedResult<IBundleDefinition>

    return observableOf(paged)
  }
  onSubmit(): void {
    const errors = []

    if (!this.model.Name) {
      errors.unshift('Name is required.')
    }

    this.toastr.clear()
    if (errors.length > 0) {
      this.toastr.error(errors.join('<br />'))
      return
    }

    const model = {
      Id: +this.model.Id || undefined,
      Name: this.model.Name,
      EpisodeTypeName: this.model.EpisodeTypeName || null,
      SystemEpisodeTypeId: this.model.SystemEpisodeTypeId,
      AccountingEpisodeTypeName: this.model.AccountingEpisodeTypeName || null,
      AtRisk: this.model.AtRisk,
      Description: this.model.Description || null,
      RefDiagnosisRelatedGroupId: this.model.RefDiagnosisRelatedGroupId
    }

    const observable = model.Id
      ? this.odata.put(model as IBundleDefinition, model.Id).exec()
      : this.odata.post(model as IBundleDefinition).exec()

    this.busy = observable.subscribe(response => {
      this.showSuccess('Bundle Definition was saved successfully.')
    }, this.showError.bind(this))
  }

  showSuccess(successMessage: string): void {
    this.busy = null
    this.backToList(successMessage)
  }

  showError(response): void {
    this.busy = null

    const msg = this.util.getErrorString(response)

    this.toastr.error(msg)
  }

  backToList(successMessage: string = null): void {
    this.router.navigate(['/system', 'bundledefinitions'], {
      queryParams: { successMessage }
    })
  }
}
